

<template>
  <div>   
    <v-container class="mt-5" style="max-width: 550px;">
      <v-card raised>
        <v-card-title>
          <div v-html="$t('labels.MTGAppSubmittedTitle')"></div>
        </v-card-title>

        <v-card-text style="color:black;">
            <div class="text-center mb-10" style="color: green;">
              <i class="  fas fa-check-circle fa-5x"></i>
            </div>
            <div v-html="$t('labels.MTGAppSubmittedDesc')" />
        </v-card-text>
       
      </v-card>
    </v-container>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import localStorageSvc from "@/services/localStorage";
import dataSvc from "@/services/dataService";
export default {  
  data() {
    return {          
      loadFlag: false,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null      
    }
  },
  methods: {
     
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID
      };

      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoad", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;
          }
        });
    }
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      //this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  mounted(){
    setTimeout(()=>{
      window.location = '/' + this.siteID + '/user/mydeals' ;
    }, 5000);
  }

};
</script>
